// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"00acc0ed","719":"71e3a570","944":"ae7b6016"}[chunkId] + ".chunk.js";
};